import * as React from 'react';
import { useEffect, useState } from 'react';
import { UserListView } from './view';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useUserListQuery } from '../../../types/generated';
import { Container, Input } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { PageHeading } from '../../../components/PageHeading';
import { useUser } from '../../../utils/user';
import { useNavigate } from 'react-router-dom';

// Delete once we've added support for imports from common in the appstore app
const useDebounce = (value: string, delay: number) => {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(
        () => {
            // Update debounced value after delay
            const handler = setTimeout(() => {
                setDebouncedValue(value);
            }, delay);

            // Cancel the timeout if value changes (also on delay change or unmount)
            // This is how we prevent debounced value from updating if value is changed ...
            // .. within the delay period. Timeout gets cleared and restarted.
            return () => {
                clearTimeout(handler);
            };
        },
        [value, delay] // Only re-call effect if value or delay changes
    );

    return debouncedValue;
};

export function UserList() {
    const navigate = useNavigate();
    const user = useUser();
    const [searchTerm, setSearchTerm] = useState<string>('');
    const debouncedSearchTerm = useDebounce(searchTerm, 500);
    const query = {
        filter: {
            searchTerm: debouncedSearchTerm,
        },
        first: 50,
    };

    const { data, refetch } = useUserListQuery({ variables: query });

    const onCreate = () => {
        navigate('/extranet/team/add');
    };

    const refetchUsers = () => {
        refetch(query);
    };

    useEffect(() => {
        refetchUsers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (data) {
        return (
            <>
                <Container maxWidth={'md'}>
                    <PageHeading
                        title={
                            <Input
                                placeholder={'Search for user'}
                                value={searchTerm}
                                onChange={event => setSearchTerm(event.target.value)}
                            />
                        }
                    >
                        {(user?.accountOwner ?? false) && (
                            <Button
                                variant="contained"
                                size="small"
                                color="primary"
                                onClick={onCreate}
                            >
                                + Create user
                            </Button>
                        )}
                    </PageHeading>
                </Container>
                <UserListView
                    list={data && data.appAccountUserList.edges}
                    onDelete={() => refetchUsers()}
                    user={user}
                />
            </>
        );
    } else {
        return <CircularProgress />;
    }
}
